import React, {useEffect} from 'react';
import './App.css';
// import StatusBar from './components/StatusBar';
// import TabNavigation from './components/TabNavigation';
import MainTab from './components/MainTab';
// import ConfigurationTab from './components/ConfigurationTab';
import TokensContext from './TokensContext';

function App() {
  // const [selectedTab, setSelectedTab] = React.useState(1);
  const [tokens, setTokens] = React.useState(null);
  const [error, setError] = React.useState(null);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const user = urlParams.get('user');

    if (!user) {
      setError('No user parameter provided');
      return;
    }

    // Use regular expression to allow only alphanumeric characters
    const regex = /^[a-z0-9-]+$/i;

    if (!regex.test(user)) {
      setError('Invalid user parameter provided');
      return;
    }

    let backEndBaseUrl;
    if (user === "local") //used when working on changes on the back end which are not available on the server.
      backEndBaseUrl = "http://localhost:5000"
    else
      // backEndBaseUrl = `http://${user}.smartheaters.duckdns.org`;
      backEndBaseUrl = `https://${user}.eatec.com.ar`; //uncomment to continue troubleshooting ssl support.
    /* SSL support: uncommenting the above fixes an issue that I had with CORS. So there's a current pending change locally that adds HTTPS://eatec.com.ar as a supported cors that's on the backend that's on the appsettings, not yet added to git. it's already published to ofi's appsettings.  Still HTTPS is not working. There is another issue right now with actually getting the data from Blink. So the request to my own backend works okay, but then the request to Blink fails. That's the current situation.
    
    followup. these work:
    http://smartheaters.duckdns.org:8080/H8d1CE8mS019fZX7g2-Lvx5bE1Gxh-Gh/get/V8
    http://blynk.eatec.com.ar:8081/H8d1CE8mS019fZX7g2-Lvx5bE1Gxh-Gh/get/V8
    
    this works if using the "advanced" and skipping warnings.
    https://blynk.eatec.com.ar:9443/H8d1CE8mS019fZX7g2-Lvx5bE1Gxh-Gh/get/V8
    the url is set on .env, i need to get blynk working over https.
    see chat  "Nginx HTTPS alternative inquiry"

    fixed. i think now I need to update the urls and try again.
    */

    const url = backEndBaseUrl + "/api/Token/devices";
    const invertedHeater = (user.toLocaleLowerCase() === 'lgt' || user.toLocaleLowerCase() === 'lgt-cuarto' || user.toLocaleLowerCase() === 'panque') //TODO: instead of deciding based on the user, it should be provided by the back end. Add settings to the env or at assume it's flipped if using position translator
    const heaterOnly = false; //for users that have heaters only and no termo, none currently in use
    
    fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        if(data.heaters.length > 0) {
          setTokens({
            heaters: data.heaters,
            thermometerToken: data.thermometer.token,
            backEndBaseUrl: backEndBaseUrl,
            invertedHeater: invertedHeater,
            heaterOnly: heaterOnly,
          });
        } else {
          setError('No heater tokens found');
        }
      })
      .catch(err => setError(err.message));
  }, []);

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!tokens) {
    return <div>Loading...</div>;
  }

  else {
    return (
      <div className="App container">
        <TokensContext.Provider value={tokens}>
          {/* <StatusBar />
          <TabNavigation selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
          {selectedTab === 1 && <MainTab />}
          {selectedTab === 2 && <ConfigurationTab />} */}
          <MainTab />
        </TokensContext.Provider>
      </div>
    );
  }
}

export default App;
